import type { Room, ScheduleData } from './types';

const idleRoomNames = [
  '岳麓主校区 A301',
  '岳麓主校区 A302',
  '梅溪湖校区 B101',
  '梅溪湖校区 B102',
  '梅溪湖校区 B201',
  '梅溪湖校区 B202',
  '梅溪湖校区 B301',
  '梅溪湖校区 B302',
  '雨花校区 C101',
  '雨花校区 C102',
  '雨花校区 C201',
  '雨花校区 C202',
  '星沙校区 D101',
  '星沙校区 D102',
  '星沙校区 D201',
  '星沙校区 D202',
  '河西校区 E101',
  '河西校区 E102',
  '河西校区 E201',
  '河西校区 E202',
  '滨江校区 F101',
  '滨江校区 F102',
  '滨江校区 F201',
  '滨江校区 F202',
  '少儿美术教室',
  '多功能报告厅'
];

const idleRooms: Room[] = idleRoomNames.map((name, index) => ({
  id: `idle-room-${index + 1}`,
  name,
  status: 'idle',
  summaryText: index < 2 ? '今日课程已结束' : '今日无课'
}));

export const mockSchedule: ScheduleData = {
  date: '2026-09-04',
  systemTime: '2026-09-04T11:23:36',
  rooms: [
    {
      id: 'yuelu-a101',
      name: '岳麓主校区 A101',
      status: 'current',
      courseName: '高一物理强化班·竞赛实验专题课程',
      startTime: '11:00',
      endTime: '11:50',
      teacherName: '周启明'
    },
    {
      id: 'yuelu-a102',
      name: '岳麓主校区 A102',
      status: 'current',
      courseName: '初三英语冲刺班',
      startTime: '11:10',
      endTime: '12:00',
      teacherName: '林晓雯'
    },
    {
      id: 'yuelu-a201',
      name: '岳麓主校区 A201',
      status: 'future',
      courseName: '高二数学培优班',
      startTime: '13:30',
      endTime: '14:50',
      teacherName: '陈子航'
    },
    {
      id: 'yuelu-a202',
      name: '岳麓主校区 A202',
      status: 'future',
      courseName: '少儿编程进阶班',
      startTime: '15:00',
      endTime: '16:20',
      teacherName: '唐若溪'
    },
    ...idleRooms
  ],
  courses: [
    {
      id: 'a101-math-morning',
      roomId: 'yuelu-a101',
      name: '高一数学基础班',
      startTime: '2026-09-04T08:00:00',
      endTime: '2026-09-04T08:50:00',
      teacherName: '刘书言',
      assistantName: '王可',
      headTeacherName: '李敏',
      attendanceCount: 18,
      studentCount: 18
    },
    {
      id: 'a101-chemistry-morning',
      roomId: 'yuelu-a101',
      name: '高一化学提升班',
      startTime: '2026-09-04T09:10:00',
      endTime: '2026-09-04T10:00:00',
      teacherName: '蒋文清',
      assistantName: '—',
      headTeacherName: '李敏',
      attendanceCount: 0,
      studentCount: 16
    },
    {
      id: 'a101-physics-current',
      roomId: 'yuelu-a101',
      name: '高一物理强化班·竞赛实验专题课程',
      startTime: '2026-09-04T11:00:00',
      endTime: '2026-09-04T11:50:00',
      teacherName: '周启明',
      assistantName: '宋佳',
      headTeacherName: '李敏',
      attendanceCount: 20,
      studentCount: 22
    },
    {
      id: 'a101-chinese-afternoon',
      roomId: 'yuelu-a101',
      name: '高二语文阅读班',
      startTime: '2026-09-04T14:00:00',
      endTime: '2026-09-04T15:20:00',
      teacherName: '许知远',
      assistantName: '—',
      headTeacherName: '赵晴',
      attendanceCount: 0,
      studentCount: 20
    },
    {
      id: 'a101-evening-study',
      roomId: 'yuelu-a101',
      name: '高一晚间自习答疑',
      startTime: '2026-09-04T18:30:00',
      endTime: '2026-09-04T20:00:00',
      teacherName: '周启明',
      assistantName: '宋佳',
      headTeacherName: '李敏',
      attendanceCount: 0,
      studentCount: 24
    },
    {
      id: 'a102-english-current',
      roomId: 'yuelu-a102',
      name: '初三英语冲刺班',
      startTime: '2026-09-04T11:10:00',
      endTime: '2026-09-04T12:00:00',
      teacherName: '林晓雯',
      assistantName: '赵蕾',
      headTeacherName: '孙倩',
      attendanceCount: 0,
      studentCount: 20
    },
    {
      id: 'a201-math-future',
      roomId: 'yuelu-a201',
      name: '高二数学培优班',
      startTime: '2026-09-04T13:30:00',
      endTime: '2026-09-04T14:50:00',
      teacherName: '陈子航',
      assistantName: '—',
      headTeacherName: '吴婷',
      attendanceCount: 0,
      studentCount: 18
    },
    {
      id: 'a202-programming-future',
      roomId: 'yuelu-a202',
      name: '少儿编程进阶班',
      startTime: '2026-09-04T15:00:00',
      endTime: '2026-09-04T16:20:00',
      teacherName: '唐若溪',
      assistantName: '何安',
      headTeacherName: '周宁',
      attendanceCount: 8,
      studentCount: 12
    },
    {
      id: 'a301-physics-past',
      roomId: 'idle-room-1',
      name: '高三物理冲刺班',
      startTime: '2026-09-04T08:30:00',
      endTime: '2026-09-04T09:20:00',
      teacherName: '周启明',
      assistantName: '—',
      headTeacherName: '李敏',
      attendanceCount: 0,
      studentCount: 22
    },
    {
      id: 'a302-english-past',
      roomId: 'idle-room-2',
      name: '初二英语提高班',
      startTime: '2026-09-04T09:30:00',
      endTime: '2026-09-04T10:20:00',
      teacherName: '林晓雯',
      assistantName: '赵蕾',
      headTeacherName: '孙倩',
      attendanceCount: 18,
      studentCount: 18
    }
  ]
};
